// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Headers
 */
/*
  Base Sizing
 */
/*
  Colors
 */
/*
  Border Radii Sizes
 */
/*
  Shadows
 */
/*
  Global Styles
 */
html {
  font-size: 10px;
}

/**
 * COODE Header Colors
 */
.collapsible-bg {
  background-color: white;
}
.warning-inline-notification {
  margin-top: 1.6rem;
}
.warning-inline-notification.pui-form-inline-notification--warning {
  background-color: rgba(251, 146, 60, 0.2);
  border-color: #ea580c;
}
.warning-inline-notification.pui-form-inline-notification--warning path {
  color: #ea580c;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
